'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uiTranslations = require('@wh/ui-translations');

var _register = require('./register');

var _register2 = _interopRequireDefault(_register);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _uiTranslations.withTranslator)(_register2.default);
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/register/Container.js
// module id = 500
// module chunks = 0